import React from "react";
import {Button, ButtonGroup, FormItem, Input} from "@vkontakte/vkui";
import SelectObject from "../../assets/SelectObject";
import TrademarksApi from "../../api/references/trademarks";
import * as constants from "../../assets/constants";

const rememberTrademark = (item) => {
    let cached = {}
    try {
        cached = JSON.parse(localStorage.getItem(constants.trademarks_cache_key) || '{}') || {}
    } catch (e) {
        cached = {}
    }
    if (cached[''] === undefined) cached[''] = 'Не указана'
    cached[item.id] = item.title
    localStorage.setItem(constants.trademarks_cache_key, JSON.stringify(cached))
}

/**
 * Выбор торговой марки с созданием новой, не закрывая форму стенда.
 * Плюс в шапке списка включается пропом create_action.
 */
class TrademarkSelectObject extends SelectObject {

    createAction() {
    }

    onCreated = (value) => {
        const item = {
            ...value,
            uid: value.uid || value.id,
            name: value.title,
            title: value.title,
        }
        rememberTrademark(item)
        this.setState({current_object: item})
        if (this.props.selectObject) this.props.selectObject(item)
        window.postMessage('closeSelectObject' + this.guid)
    }

    renderCreateForm() {
        return <TrademarkQuickForm
            onCreated={this.onCreated}
            onCancel={() => this.setActiveModal(constants.MODAL_LIST_OBJECTS)}
        />
    }
}

class TrademarkQuickForm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {title: '', saving: false}
    }

    openError = (text) => {
        window.postMessage({type: 'error', text, timeout: 2000})
    }

    save = async () => {
        const title = this.state.title.trim()
        if (!title) {
            this.openError('Укажите наименование торговой марки')
            return
        }
        this.setState({saving: true})
        try {
            const result = await TrademarksApi.save({title})
            this.setState({saving: false})
            if (result.data && result.data.error) {
                this.openError(result.data.error)
                return
            }
            if (result.data && result.data.id) {
                window.postMessage({type: 'success', text: 'Торговая марка сохранена', timeout: 1500, hideSpinner: true})
                this.props.onCreated(result.data)
            } else {
                this.openError('Не удалось сохранить торговую марку')
            }
        } catch (e) {
            this.setState({saving: false})
            this.openError('Не удалось сохранить торговую марку')
        }
    }

    render() {
        return <div className="stand-kit-form">
            <div className="stand-kit-form__body">
                <FormItem top="Наименование">
                    <Input value={this.state.title} onChange={e => this.setState({title: e.target.value})}/>
                </FormItem>
            </div>
            <div className="stand-kit-form__actions">
                <ButtonGroup mode="horizontal" stretched>
                    <Button stretched size="l" mode="secondary" disabled={this.state.saving}
                            onClick={this.props.onCancel}>Отмена</Button>
                    <Button stretched size="l" disabled={this.state.saving} onClick={this.save}>Сохранить</Button>
                </ButtonGroup>
            </div>
        </div>
    }
}

export default TrademarkSelectObject
